"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdjustmentDataComponent = void 0;
const core_1 = require("@angular/core");
let AdjustmentDataComponent = class AdjustmentDataComponent {
    constructor() {
        this.blurred = new core_1.EventEmitter();
    }
    onBlur($event) {
        let number = isNaN(parseFloat($event.target.value)) ? null : parseFloat($event.target.value);
        if ((String(this.rowData[this.header]) !== String(number)) && (number !== null)) {
            this.adjustmentValue = Number(this.parse(number));
            this.rowData.update({ metric: this.header, value: this.adjustmentValue });
            // if it has an hour kvp, then it's hourly
            this.account.cascadeChanges(this.header, this.rowData.hour);
        }
    }
    parse(val) {
        if (this.header === 'impsAdj') {
            return parseInt(val).toFixed(0);
        }
        return parseFloat(val);
    }
};
exports.AdjustmentDataComponent = AdjustmentDataComponent;
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Object)
], AdjustmentDataComponent.prototype, "rowData", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Object)
], AdjustmentDataComponent.prototype, "account", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Object)
], AdjustmentDataComponent.prototype, "header", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Boolean)
], AdjustmentDataComponent.prototype, "isReadOnly", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Number)
], AdjustmentDataComponent.prototype, "adjustmentValue", void 0);
__decorate([
    (0, core_1.Output)(),
    __metadata("design:type", core_1.EventEmitter)
], AdjustmentDataComponent.prototype, "blurred", void 0);
exports.AdjustmentDataComponent = AdjustmentDataComponent = __decorate([
    (0, core_1.Component)({
        selector: 'adjustment-data',
        templateUrl: 'app/adjustment-data.component.html',
        styleUrls: ['styles/adjustment.component.css']
    })
], AdjustmentDataComponent);
//# sourceMappingURL=adjustment-data.component.js.map